"use client";

import { useDictionary } from "../context/dictionaryProvider";
import { ContentContainer } from "./molecules";

const NoSearchFound = () => {
  const dict = useDictionary();

  return (
    <ContentContainer>
      <section className="flex items-center justify-center h-full border-small rounded-md py-10 my-10 max-h-64" id="search-result">
        <div className="text-center">
          <h2 className="text-[32px] lg:text-5xl css-ibyfs3">
            {dict?.noResult?.title}
          </h2>
          <p className="text-start-600 mt-2 text-[16px] md:text-[20px]">
            {dict?.noResult?.description}
          </p>
          <p className="text-start-600 mt-2 text-[16px] md:text-[20px]">
            {dict?.noResult?.alternatively} {" "}
            <a
              href="https://learnerspoint.org/browsecourses"
              className="text-blue-500 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {dict?.noResult?.browseThroughCatalougues}
            </a>{" "}
            {dict?.or}{" "}
            <a
              href="https://learnerspoint.org/contact"
              className="text-blue-500 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {dict?.contactUs.toLowerCase()}
            </a>{" "}
            {dict?.noResult?.customRequirements}
          </p>
        </div>
      </section>
    </ContentContainer>
  );
};

export default NoSearchFound;
